import { NgModule } from '@angular/core';
import { CEPService } from './services/cep/cep.service';
import { CrudLessorLibService } from './services/crud-lessor/crud-lessor-lib.service';
import { UtilService } from './utils/utils.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [CrudLessorLibService, CEPService, UtilService],
})
export class CoreModule {}
